export default __webpack_public_path__ + "static/media/af.06ff9155.svg";